import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "../VehiculeForm.css";
import api from '../../../api/config';

const StepThreeNeuf = ({ sendData, isActive, onNext, onPrevious, commonData, handleSave }) => {
    const [formData, setFormData] = useState({
       // VEHICULE EN LOCATION
       loc_0: null, // "Le véhicule est-il pris en location ?" 0: pas en location 1: en location
       // si oui
       loc_1: null, // "Type de location :" 0: courte duree 1: longue duree
       // si longue duree
       loc_3: null, // "Raison sociale de la societe de location, si différente du titualaire"
       loc_4: null, // "N° SIRET, le cas échéant :"
       // longue duree ET courte duree
       loc_5: null, // "Le locataire est :" 0: personne physique 1: personne morale
       //    si physique
       loc_6: null, // "Nom et prénom :"
       // si moral
       loc_7: null, // "Raison sociale"
       loc_8: null, // ""N° SIRET"

       // DOMICILE  (si location, veuillez indiquer le domicile du locataire)
       loc_9: null, // "N° de la voie :"
       loc_10: null, // "Complément (bis, ter, ..) :"
       loc_11: null, // "Type de voie (rue, avenue,..) :"
       loc_12: null, // "Nom de la voie"
       loc_13: null, // "Code postal :"
       loc_14: null, // "Commune :"
       loc_15: null, // "Téléphone portable"
       loc_16: null, // "Adresse mail :"
    });

    useEffect(() => {
        if (commonData) {
            if (commonData.stepThreeData && Object.keys(commonData.stepThreeData).length > 0) {
                setFormData(prevState => ({
                    ...prevState,
                    ...commonData.stepThreeData
                }));
            } else {
                const { numero_dossier, statut, vendeur_id } = commonData;
                setFormData(prevState => ({
                    ...prevState,
                    numero_dossier,
                    statut,
                    vendeur_id
                }));
            }
        }
    }, [commonData]);

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
        
    //     const numericOnlyFields = ['loc_4', 'loc_8', 'loc_9', 'loc_13', 'loc_15'];
        
    //     const caseSensitiveFields = ['loc_16']; // email
        
    //     if (numericOnlyFields.includes(name)) {
    //         const numericValue = value.replace(/[^0-9]/g, '');
    //         setFormData({
    //             ...formData,
    //             [name]: numericValue
    //         });
    //         return;
    //     }
        
    //     if (caseSensitiveFields.includes(name)) {
    //         setFormData({
    //             ...formData,
    //             [name]: value
    //         });
    //         return;
    //     }
        
    //     setFormData({
    //         ...formData,
    //         [name]: value.toUpperCase()
    //     });
    // };
    const handleInputChange = (e) => {
      const { name, value } = e.target;

      const caseSensitiveFields = ['loc_16']; // email
      const numericOnlyFields = ['loc_4', 'loc_9', 'loc_13', 'loc_15'];

      setFormData(prev => {
        let next = { ...prev };

        // --- LOCATAIRE : saisie personne physique ---
        if (name === 'loc_6') {
          next = {
            ...next,
            loc_6: value.toUpperCase(),
            loc_5: '0',   // personne physique
            loc_7: null,
            loc_8: null,
          };
        }
        // --- LOCATAIRE : personne morale (raison sociale / SIRET) ---
        else if (name === 'loc_7') {
          next = {
            ...next,
            loc_7: value.toUpperCase(),
            loc_5: '1',   // personne morale
            loc_6: null,
          };
        }
        else if (name === 'loc_8') {
          const numericValue = value.replace(/[^0-9]/g, '');
          next = {
            ...next,
            loc_8: numericValue,
            loc_5: '1',   // personne morale
            loc_6: null,
          };
        }
        // --- Champs numériques simples ---
        else if (numericOnlyFields.includes(name)) {
          const numericValue = value.replace(/[^0-9]/g, '');
          next = {
            ...next,
            [name]: numericValue,
          };
        }
        // --- Email (sensible à la casse) ---
        else if (caseSensitiveFields.includes(name)) {
          next = {
            ...next,
            [name]: value,
          };
        }
        // --- Fallback : majuscules ---
        else {
          next = {
            ...next,
            [name]: value.toUpperCase(),
          };
        }

        // Synchronisation avec le parent
        if (typeof sendData === 'function') {
          sendData(next);
        }

        return next;
      });
    };


    // const handleRadioChange = (name, value) => {
    //     // console.log(`[handleRadioChange] Champ ${name} mis à jour avec la valeur :`, value);
    //     setFormData({
    //         ...formData,
    //         [name]: value
    //     });
    // };
    const handleRadioChange = (name, value) => {
        setFormData(prev => {
            const updated = { ...prev, [name]: value };

            // Véhicule en location : si NON, on nettoie tout le bloc loc_*
            if (name === 'loc_0' && value === '0') {
                updated.loc_1 = null;
                updated.loc_3 = null;
                updated.loc_4 = null;
                updated.loc_5 = null;
                updated.loc_6 = null;
                updated.loc_7 = null;
                updated.loc_8 = null;
                updated.loc_9 = null;
                updated.loc_10 = null;
                updated.loc_11 = null;
                updated.loc_12 = null;
                updated.loc_13 = null;
                updated.loc_14 = null;
                updated.loc_15 = null;
                updated.loc_16 = null;
            }

            // Type de location : si on repasse en COURTE durée, on peut nettoyer les champs du loueur long terme
            if (name === 'loc_1' && value === '0') {
                updated.loc_3 = null;
                updated.loc_4 = null;
            }

            // Type de locataire
            if (name === 'loc_5') {
                if (value === '0') {
                    // locataire personne physique
                    updated.loc_7 = null;
                    updated.loc_8 = null;
                } else if (value === '1') {
                    // locataire personne morale
                    updated.loc_6 = null;
                }
            }

            if (typeof sendData === 'function') {
              sendData(updated);
            }
            
            return updated;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        sendData(formData);
        if (handleSave) handleSave(formData);
        if (onNext) onNext();
    };

    const handlePrevious = () => {
        sendData(formData);
        if (onPrevious) onPrevious();
    };

    // Appel à l'API Sirene
    const [modalData, setModalData] = useState(null);
    const [modalError, setModalError] = useState(null);

    const handleSireneLookup = async (target) => {
        const siret = target === 'loueur' ? formData.loc_4 : formData.loc_8;
        const cleaned = (siret || "").replace(/\D/g, "");
        if (cleaned.length !== 14) {
            setModalError("Le numéro SIRET doit contenir 14 chiffres.");
            return;
        }

        try {
            const { data } = await api.get(`/insee/verify/${cleaned}`);
            const etab = data.etablissement;
            const adr = etab?.adresseEtablissement || {};
            const denomination =
                etab?.uniteLegale?.denominationUniteLegale ||
                etab?.uniteLegale?.nomUniteLegale ||
                etab?.uniteLegale?.prenomUsuelUniteLegale ||
                '';

            setFormData(prev => {
                const updates = {};

                if (target === 'loueur') {
                    // MAJ uniquement la section loueur
                    updates.loc_4 = cleaned; // SIRET Loueur
                    if (!prev.loc_3 && denomination) {
                        updates.loc_3 = denomination; // Raison sociale loueur si vide
                    }
                } else {
                    // Maj uniquement la section locataire (personne morale)
                    updates.loc_8 = cleaned; // SIRET locataire
                    if (!prev.loc_7 && denomination) {
                        updates.loc_7 = denomination; // Raison sociale locataire si vide
                    }
                    // Adresse du locataire
                    updates.loc_9  = adr.numeroVoieEtablissement      || prev.loc_9;
                    updates.loc_11 = adr.typeVoieEtablissement        || prev.loc_11;
                    updates.loc_12 = adr.libelleVoieEtablissement     || prev.loc_12;
                    updates.loc_13 = adr.codePostalEtablissement      || prev.loc_13;
                    updates.loc_14 = adr.libelleCommuneEtablissement  || prev.loc_14;
                }
                return { ...prev, ...updates };
            })       

            setModalError(null);
            setModalData(data);
        } catch (err) {
            setModalError("SIRET introuvable ou erreur API.");
            setModalData(null);
        }
    };


    if (!isActive) return null;

    return (
        <>
            <div className="section">
                <h3>VÉHICULE EN LOCATION</h3>
                
                <div className="radio-group">
                    <label>LE VÉHICULE EST-IL PRIS EN LOCATION?</label>
                    <div className='radio-group-child'>
                    <div>
                        <input
                            type="radio"
                            id="loc_0_oui"
                            name="loc_0"
                            value="1"
                            checked={formData.loc_0 === '1'}
                            onChange={() => handleRadioChange('loc_0', '1')}
                            required
                        />
                        <label htmlFor="loc_0_oui">OUI</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="loc_0_non"
                            name="loc_0"
                            value="0"
                            checked={formData.loc_0 === '0'}
                            onChange={() => handleRadioChange('loc_0', '0')}
                            required
                        />
                        <label htmlFor="loc_0_non">NON</label>
                    </div>
                    </div>
                </div>
    
                {/* Fields shown only if vehicle is rented */}
                {formData.loc_0 === '1' && (
                    <>
                        <div className="radio-group">
                            <label>TYPE DE LOCATION:</label>
                            <div className='radio-group-child'>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_1_courte"
                                    name="loc_1"
                                    value="0"
                                    checked={formData.loc_1 === '0'}
                                    onChange={() => handleRadioChange('loc_1', '0')}
                                    required
                                />
                                <label htmlFor="loc_1_courte">COURTE DURÉE</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_1_longue"
                                    name="loc_1"
                                    value="1"
                                    checked={formData.loc_1 === '1'}
                                    onChange={() => handleRadioChange('loc_1', '1')}
                                    required
                                />
                                <label htmlFor="loc_1_longue">LONGUE DURÉE</label>
                            </div>
                            </div>
                        </div>
    
                        {formData.loc_1 === '1' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="loc_3">RAISON SOCIALE DE LA SOCIÉTÉ DE LOCATION, SI DIFFÉRENTE DU TITULAIRE:</label>
                                    <input
                                        type="text"
                                        id="loc_3"
                                        name="loc_3"
                                        value={formData.loc_3 || ''}
                                        onChange={handleInputChange}
                                        maxLength={100}
                                    />
                                </div>
    
                                <div className="form-group siret-group">
                                    <div className='input-group'>
                                        <label htmlFor="loc_4">N° SIRET, LE CAS ÉCHÉANT:</label>
                                        <input
                                            type="text"
                                            id="loc_4"
                                            name="loc_4"
                                            value={formData.loc_4 || ''}
                                            onChange={handleInputChange}
                                            pattern="[0-9]{14}"
                                            title="Le numéro SIRET doit contenir 14 chiffres"
                                            maxLength={14}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="save-button"
                                        onClick={() => handleSireneLookup('loueur')}
                                    >
                                        Vérifier le SIRET
                                    </button>
                                </div>
                            </>
                        )}
    
                        <div className="radio-group">
                            <label>LE LOCATAIRE EST:</label>
                            <div className='radio-group-child'>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_5_physique"
                                    name="loc_5"
                                    value="0"
                                    checked={formData.loc_5 === '0'}
                                    onChange={() => handleRadioChange('loc_5', '0')}
                                    required
                                />
                                <label htmlFor="loc_5_physique">PERSONNE PHYSIQUE</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_5_moral"
                                    name="loc_5"
                                    value="1"
                                    checked={formData.loc_5 === '1'}
                                    onChange={() => handleRadioChange('loc_5', '1')}
                                    required
                                />
                                <label htmlFor="loc_5_moral">PERSONNE MORALE</label>
                            </div>
                            </div>
                        </div>
    
                        {formData.loc_5 === '0' && (
                            <div className="form-group">
                                <label htmlFor="loc_6">NOM ET PRÉNOM:</label>
                                <input
                                    type="text"
                                    id="loc_6"
                                    name="loc_6"
                                    value={formData.loc_6 || ''}
                                    onChange={handleInputChange}
                                    pattern="[A-Za-zÀ-ÿ\s\-']+"
                                    title="Veuillez entrer un nom et prénom valide"
                                    maxLength={100}
                                    required
                                />
                            </div>
                        )}
    
                        {formData.loc_5 === '1' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="loc_7">RAISON SOCIALE:</label>
                                    <input
                                        type="text"
                                        id="loc_7"
                                        name="loc_7"
                                        value={formData.loc_7 || ''}
                                        onChange={handleInputChange}
                                        maxLength={100}
                                        required
                                    />
                                </div>
    
                                <div className="form-group siret-group">
                                    <div className='input-group'>
                                        <label htmlFor="loc_8">N° SIRET:</label>
                                        <input
                                            type="text"
                                            id="loc_8"
                                            name="loc_8"
                                            value={formData.loc_8 || ''}
                                            onChange={handleInputChange}
                                            pattern="[0-9]{14}"
                                            title="Le numéro SIRET doit contenir 14 chiffres"
                                            maxLength={14}
                                            required
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="save-button"
                                        onClick={() => handleSireneLookup('locataire')}
                                    >
                                        Vérifier le SIRET
                                    </button>
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
    
            {formData.loc_0 === '1' && (
              <div className="section">
                <h3>DOMICILE (si location, veuillez indiquer le domicile du locataire)</h3>
                
                <div className="form-group">
                    <label htmlFor="loc_9">N° DE LA VOIE:</label>
                    <input
                        type="text"
                        id="loc_9"
                        name="loc_9"
                        value={formData.loc_9 || ''}
                        onChange={handleInputChange}
                        pattern="[0-9]+"
                        title="Veuillez entrer un numéro valide"
                        maxLength={10}
                    />
                </div>
    
                <div className="form-group">
                    <label htmlFor="loc_10">COMPLÉMENT (BIS, TER, ...):</label>
                    <input
                        type="text"
                        id="loc_10"
                        name="loc_10"
                        value={formData.loc_10 || ''}
                        onChange={handleInputChange}
                        maxLength={20}
                    />
                </div>
    
                <div className="form-group">
                    <label htmlFor="loc_11">TYPE DE VOIE (RUE, AVENUE...):</label>
                    <input
                        type="text"
                        id="loc_11"
                        name="loc_11"
                        value={formData.loc_11 || ''}
                        onChange={handleInputChange}
                        pattern="[A-Za-zÀ-ÿ\s\-']+"
                        title="Veuillez entrer un type de voie valide"
                        maxLength={30}
                        required
                    />
                </div>
    
                <div className="form-group">
                    <label htmlFor="loc_12">NOM DE LA VOIE:</label>
                    <input
                        type="text"
                        id="loc_12"
                        name="loc_12"
                        value={formData.loc_12 || ''}
                        onChange={handleInputChange}
                        pattern="[A-Za-zÀ-ÿ0-9\s\-'.]+"
                        title="Veuillez entrer un nom de voie valide"
                        maxLength={100}
                        required
                    />
                </div>
    
                <div className="form-group">
                    <label htmlFor="loc_13">CODE POSTAL:</label>
                    <input
                        type="text"
                        id="loc_13"
                        name="loc_13"
                        value={formData.loc_13 || ''}
                        onChange={handleInputChange}
                        pattern="[0-9]{5}"
                        title="Le code postal doit contenir 5 chiffres"
                        maxLength={5}
                        required
                    />
                </div>
    
                <div className="form-group">
                    <label htmlFor="loc_14">
                        COMMUNE:
                        <span className="tooltip-icon" title="Pour les grandes villes, indiquez le n° d'arrondissement.">?</span>
                    </label>
                    <input
                        type="text"
                        id="loc_14"
                        name="loc_14"
                        value={formData.loc_14 || ''}
                        onChange={handleInputChange}
                        pattern="[A-Za-zÀ-ÿ\s\-'0-9]+"
                        title="Veuillez entrer une commune valide"
                        maxLength={100}
                        required
                    />
                </div>
    
                <div className="form-group">
                    <label htmlFor="loc_15">TÉLÉPHONE PORTABLE:</label>
                    <input
                        type="tel"
                        id="loc_15"
                        name="loc_15"
                        value={formData.loc_15 || ''}
                        onChange={handleInputChange}
                        pattern="0[1-9][0-9]{8}"
                        title="Le numéro de téléphone doit être au format français (10 chiffres commençant par 0)"
                        maxLength={10}
                        required
                    />
                </div>
    
                <div className="form-group">
                  <label htmlFor="loc_16">ADRESSE MAIL:</label>
                  <input
                      type="email"
                      id="loc_16"
                      name="loc_16"
                      value={formData.loc_16 || ''}
                      onChange={handleInputChange}
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                      title="Veuillez entrer une adresse email valide"
                      maxLength={100}
                      required
                  />
                </div>
              </div>
            )}

            {modalData && (
              <div className="modal-overlay">
                  <div className="modal-content modal-insee">
                      <h3>Informations Entreprise</h3>
                      <p><strong>Raison sociale :</strong> {modalData.etablissement?.uniteLegale?.denominationUniteLegale || "[Non renseignée]"}</p>
                      <p><strong>Adresse :</strong> {[modalData.etablissement?.adresseEtablissement?.numeroVoieEtablissement, modalData.etablissement?.adresseEtablissement?.typeVoieEtablissement, modalData.etablissement?.adresseEtablissement?.libelleVoieEtablissement].filter(Boolean).join(" ") || "[Non renseignée]"}</p>
                      <p><strong>Code postal :</strong> {modalData.etablissement?.adresseEtablissement?.codePostalEtablissement || "[Non renseigné]"}</p>
                      <p><strong>Commune :</strong> {modalData.etablissement?.adresseEtablissement?.libelleCommuneEtablissement || "[Non renseignée]"}</p>
                      <button className="finish-button" onClick={() => setModalData(null)}>Fermer</button>
                  </div>
              </div>
            )}

            {modalError && (
              <div className="error-message">
                  {modalError} <button className="finish-button" onClick={() => setModalError(null)}>Fermer</button>
              </div>
            )}

    
            <div className="button-container">
              <button type="button" className="prev-button" onClick={handlePrevious}>PRÉCÉDENT</button>
              <button type="button" className="save-button" onClick={() => handleSave(formData)}>ENREGISTRER</button>
              <button type="button" className="next-button" onClick={handleSubmit}>SUIVANT</button>
            </div>
        </>
    );
};

StepThreeNeuf.propTypes = {
    sendData: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func,
    commonData: PropTypes.object,
    handleSave: PropTypes.func.isRequired,
};

export default StepThreeNeuf;